import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-todo6",
  "use": "icon-icon-todo6-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon-todo6\"><path d=\"M523.023059 466.040471c91.256471 0 161.129412-62.524235 161.129412-144.143059 0-81.859765-69.872941-144.203294-161.129412-144.203294-91.316706 0-161.069176 62.343529-161.069177 144.203294 0 81.618824 69.632 144.143059 161.069177 144.143059z m0 55.777882c-107.218824 0-326.174118 57.645176-326.174118 168.176941v120.169412h652.227765v-120.169412c0-110.531765-218.955294-168.176941-326.053647-168.176941z m-0.180706 254.855529l-53.609412-72.884706 53.609412-145.889882 53.669647 145.889882-53.609412 72.884706z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/icon-todo6.svg
// module id = WpqG
// module chunks = 3